import { Button, Card, Column, Row, TextButton, Typography, CloseButton } from 'seagull';
import { LogoPicker } from "../../../components/LogoPicker/LogoPicker";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useBrandingActions } from "../BrandingActionsContext";
import { PreviewState } from "../ClientOnboarding.utils";
import { useCobBranding } from "../CobBrandingContext";
import { useCobConfig } from "../CobConfigContext";
import styles from "./BrandingControllers.module.scss";
import { ColorsLabel, SectionTitle } from "./BrandingControllers.shared";
import { ColorSelectorWithPopup } from "./ColorSelectorWithPopup";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BrandingPanel() {
  const {
    branding,
    logoImage,
    errors,
    isDirty,
    isValid,
    setBranding,
    setLogo,
    revertToDefault,
    saveLogoAndBranding
  } = useCobBranding();
  const {
    SET_UP_BRAND_CLIENT_PREVIEW = false
  } = useFeatureFlags();
  const {
    originalPreviewState
  } = useCobConfig();
  const {
    onToggleBrandSetup
  } = useBrandingActions();
  function handleCloseClick() {
    onToggleBrandSetup();
  }
  function getColorControl(colorKey) {
    return /*#__PURE__*/_jsx(ColorSelectorWithPopup, {
      branding: branding,
      hasError: errors.has(colorKey),
      colorKey: colorKey,
      onChange: setBranding
    });
  }
  return /*#__PURE__*/_jsxs(Card, {
    padding: "s",
    className: styles.brandingCard,
    children: [SET_UP_BRAND_CLIENT_PREVIEW ? /*#__PURE__*/_jsxs(Row, {
      alignItems: "center",
      justifyContent: "space-between",
      className: styles.headerRow,
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        variant: "paragraph1",
        children: 'Customize brand'
      }), originalPreviewState !== PreviewState.SetupBrand && /*#__PURE__*/_jsx(CloseButton, {
        skin: "standard",
        onClick: handleCloseClick,
        testId: "close-branding-setup-btn"
      })]
    }) : /*#__PURE__*/_jsx(SectionTitle, {
      children: 'Upload logo'
    }), /*#__PURE__*/_jsxs(Column, {
      gap: 12,
      className: styles.scrollableContent,
      children: [/*#__PURE__*/_jsx(LogoPicker, {
        isNewUI: true,
        testId: "upload-logo",
        image: logoImage,
        onChange: setLogo
      }), /*#__PURE__*/_jsx(SectionTitle, {
        children: "Choose brand colors"
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 8,
        children: [/*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          gap: 8,
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            skin: "secondary",
            children: "Text"
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 6,
            children: [getColorControl('textStandard'), getColorControl('textSecondary')]
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          gap: 8,
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            skin: "secondary",
            children: "Buttons"
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 6,
            children: [getColorControl('buttonPrimary'), getColorControl('buttonSecondary'), getColorControl('buttonDisabled')]
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          gap: 8,
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            skin: "secondary",
            children: "Background"
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 6,
            children: [getColorControl('backgroundGradientStart'), getColorControl('backgroundGradientEnd'), getColorControl('backgroundLight'), getColorControl('backgroundStandard')]
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          alignItems: "center",
          gap: 8,
          children: [/*#__PURE__*/_jsx(ColorsLabel, {
            skin: "secondary",
            children: "Progress bar"
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 6,
            children: [getColorControl('progressBarComplete'), getColorControl('progressBarIncomplete')]
          })]
        })]
      }), /*#__PURE__*/_jsx(TextButton, {
        testId: "undo-color-changes",
        underline: "none",
        onClick: revertToDefault,
        children: "Revert to default colors"
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 10,
        alignItems: "center",
        className: styles.saveSection,
        children: [/*#__PURE__*/_jsx(Button, {
          skin: "primaryOutline",
          disabled: !isDirty || !isValid,
          testId: "save-colors",
          tooltip: {
            placement: 'top',
            title: !isDirty ? 'Nothing to save' : !isValid ? 'One of the fields is invalid' : ''
          },
          onClick: saveLogoAndBranding,
          className: SET_UP_BRAND_CLIENT_PREVIEW ? styles.saveBtn : styles.saveBtnOld,
          children: "Save changes"
        }), SET_UP_BRAND_CLIENT_PREVIEW && /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          className: styles.saveChangesInfo,
          children: "Changes saved here will apply to all of your proposals."
        })]
      })]
    })]
  });
}